import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../common/state';
import { WithNeighbors, IWithNeighborsStateProps, IWithNeighborsDispatchProps } from './WithNeighbors';
import { changeWithNeighbors } from '../../state/with_neighbors';
import { FOfferType } from '../../../utils/category';

export function mapStateToProps(state: IAppState): IWithNeighborsStateProps {
  return {
    availableOfferType: (Number(state.config.get('neighbors.availableOfferType')) as FOfferType) || FOfferType.Any,
    jsonQuery: state.filters.jsonQuery,
    currentLocation: state.filters.currentLocation,
    experiments: state.experiments,
  };
}

export function mapDispatchToProps(dispatch: Dispatch): IWithNeighborsDispatchProps {
  return {
    onWithNeighborsChanged: (withNeighbors: boolean) => {
      dispatch(changeWithNeighbors(withNeighbors));
    },
  };
}

export const WithNeighborsContainer = connect(mapStateToProps, mapDispatchToProps)(WithNeighbors);
